import React, { useState, useCallback } from "react";
import { ChevronDown, ChevronRight, Loader2 } from "lucide-react";
import { useBluelagoon } from "@bluelagoon";
import FileDiffViewer from "./FileDiffViewer";

function VersionChanges({ versionId, stepId, isFirstVersion }) {
    const [expanded, setExpanded] = useState(false);
    const [diffData, setDiffData] = useState(null);
    const [fetched, setFetched] = useState(false);
    const { call: fetchDiff, isLoading } = useBluelagoon({ method: "getVersionDiff" });

    const handleToggle = useCallback(async () => {
        if (!expanded && !fetched) {
            try {
                const res = await fetchDiff({ stepId, versionId });
                setDiffData(res?.data || res);
                setFetched(true);
            } catch {
                setDiffData(null);
                setFetched(true);
            }
        }
        setExpanded((prev) => !prev);
    }, [expanded, fetched, fetchDiff, stepId, versionId]);

    if (isFirstVersion) return null;

    return (
        <div className="mt-2">
            <button
                onClick={handleToggle}
                className="flex items-center gap-1 text-xs text-gray-500 hover:text-gray-700 transition-colors"
            >
                {isLoading ? (
                    <Loader2 className="h-3 w-3 animate-spin" />
                ) : expanded ? (
                    <ChevronDown className="h-3 w-3" />
                ) : (
                    <ChevronRight className="h-3 w-3" />
                )}
                View Changes
            </button>
            {expanded && diffData && (
                <div className="mt-2 space-y-1">
                    {diffData.changes?.length > 0 ? (
                        <>
                            {diffData.changes.map((change) => (
                                <FileDiffViewer key={change.fileName} change={change} />
                            ))}
                            <div className="text-[10px] text-gray-400 pt-1">
                                {diffData.changes.length} file{diffData.changes.length !== 1 ? "s" : ""} changed,{" "}
                                <span className="text-green-600">+{diffData.totalAdditions}</span>{" "}
                                <span className="text-red-600">-{diffData.totalDeletions}</span>
                            </div>
                        </>
                    ) : (
                        <p className="text-xs text-gray-400">No changes found</p>
                    )}
                </div>
            )}
            {expanded && fetched && !diffData && (
                <p className="mt-1 text-xs text-red-400">Failed to load changes</p>
            )}
        </div>
    );
}

export default VersionChanges;
